import "./PageImpact.css";
import Bold from "../style/styleBold";
import { Helmet } from "react-helmet-async";

const PageImpact = () => {
  return (
    <>
      <Helmet>
        <title>Impact BCGAP</title>
        <meta
          name="description"
          content="BCGAP's mission is to provide financial support to college students to promote higher education and to end college debt."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Bent Christy Graduate Assistance Program",
            alternateName: "BCGAP",
            url: "https://bcgap.org/about-bent-christy-graduate-assistance-program",
            foundingDate: "2019",
            description:
              "The Bent Christy Graduate Assistance Program is a nonprofit organization founded in 2019 to provide financial assistance to undergraduates and parents struggling with college loan repayment.",
            mission:
              "To provide financial assistance to undergraduates and parents struggling with college loan repayment and to alleviate the burden of college debt.",
            sameAs: ["https://bcgap.org"],
          })}
        </script>
      </Helmet>
      <div className="impact-section">
        <div className="impact-intro">
          <div className="title">Our Impact</div>
          <div className="intro-text">
            Bent Christy Graduate Assistance Program addresses the financial
            challenges faced by undergraduate students and families impacted by
            college loan debt. Founded in 2019, the organization provides
            targeted financial assistance to individuals struggling with
            repayment obligations, helping to reduce financial strain and
            support long-term economic stability.
          </div>
        </div>
        <div className="impact-problem impact-block">
          <div className="content">
            <div className="subtitle">The Problem</div>
            Student debt continues to place a long-term financial burden on
            graduates and families, often delaying major life milestones such as
            homeownership, career advancement, and financial independence.
            <br />
            <br />
            While higher education remains one of the most powerful tools for
            economic mobility, the rising cost of college has created persistent
            financial strain that can follow individuals long after graduation.
            For many, the weight of student loan repayment limits their ability
            to fully benefit from their education.
          </div>
          <div className="image">
            <div className="image-wrapper">
              <img src="/images/impact/impact-photo2.webp" alt="impact-photo" />
            </div>
          </div>
        </div>
        <div className="impact-response impact-block">
          <div className="subtitle">Our Response</div>

          <div className="card-wrapper">
            <div className="card">
              <div className="card-icon">
                <img
                  src="https://img.icons8.com/ios-filled/100/get-cash.png"
                  alt="bcgap-impact"
                />
              </div>
              <div className="card-text">
                <p>
                  Bent Christy Graduate Assistance Program provides direct
                  financial assistance to undergraduates and parents facing
                  challenges in managing college loan repayment.
                </p>
              </div>
            </div>
            <div className="card">
              <div className="card-icon">
                <img
                  src="https://img.icons8.com/ios-filled/100/bearish.png"
                  alt="bcgap-impact"
                />
              </div>
              <div className="card-text">
                <p>
                  Our support helps reduce immediate financial pressure,
                  allowing individuals to focus on career growth, stability, and
                  long-term success rather than ongoing financial stress.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="impact-approach impact-block">
          <div className="approach-banner">
            <div className="approach-banner-image">
              <div className="image-wrapper">
                <img
                  src="/images/impact/impact-photo3.webp"
                  alt="bcgap-impact"
                />
              </div>
            </div>
            <div className="approach-banner-text">
              <div className="subtitle">Our Approach</div>
              <div>
                We address student debt hardship through:
                <ul>
                  <li> Targeted financial assistance for repayment relief </li>
                  <li>
                    Supporting undergraduate student loan borrowers and Parent
                    PLUS loan borrowers
                  </li>
                  <li>
                    Programs designed to reduce financial stress tied to degree
                    completion and financial stability
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="impact-vision impact-block">
          <div className="vision-banner">
            <div className="subtitle">Our Vision</div>
            <div className="impact-vision-text">
              We envision a future where higher education strengthens economic
              opportunity rather than limiting it—where students and families
              can pursue academic achievement without being constrained by
              overwhelming debt.
            </div>
            <div className="image-wrapper">
              <img src="/images/impact/impact-photo4.webp" alt="" />
            </div>
          </div>
        </div>
        <div className="impact-action">
          <div className="subtitle">
            Help us reduce the burden of student debt
          </div>
          <div className="action-text">
            Your support makes it possible for students and families to move
            forward with greater financial stability and confidence.
          </div>
          <a href="/donate-bent-christy-graduate-assistance-program">
            <button className="btn-donate">Support Our Mission</button>
          </a>
        </div>
      </div>
    </>
  );
};

export default PageImpact;
